import { type GetStaticPropsContext } from 'next';
import { type NextPageWithLayout } from 'next';
import { NoSSR } from '@/components';
import { withPageAuth } from '@/lib/auth/HOC/withPageAuth';
import { getProductSidebarLayout } from '@/module/public/layout/ProductSidebarLayout';
import { CLASSROOM_ROUTES } from '@/shared/constants/routes';
import { getDefaultStaticProps } from '@/utils';
import { ClassroomListPageView } from './ClassroomListPageView';
const ClassroomPage: NextPageWithLayout = () => {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="ClassroomPage" data-sentry-source-file="index.page.tsx">
      <ClassroomListPageView data-sentry-element="ClassroomListPageView" data-sentry-source-file="index.page.tsx" />
    </NoSSR>;
};
ClassroomPage.getLayout = function (page) {
  return getProductSidebarLayout(page);
};
export default withPageAuth(ClassroomPage, {
  callbackUrl: CLASSROOM_ROUTES.list()
});
export const getStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  return getDefaultStaticProps({
    locale,
    namespaces: ['lms', 'classroom']
  });
};